import { render, staticRenderFns } from "./DiscountsTable.vue?vue&type=template&id=11a7f8f4&scoped=true"
import script from "./DiscountsTable.vue?vue&type=script&lang=js"
export * from "./DiscountsTable.vue?vue&type=script&lang=js"
import style0 from "./DiscountsTable.vue?vue&type=style&index=0&id=11a7f8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7f8f4",
  null
  
)

export default component.exports